import styled from "styled-components";
import Grid from "@material-ui/core/Grid";

export const DetailRow = styled(Grid)`
  &:not(:last-of-type) {
    margin-bottom: 15px;
  }
`;
